import type { Ref } from 'vue';
import type { CityTag } from '@/shared/api/experience';
import { SpecialTagsOrder, specialTagsSlugs } from '@/widgets/rubricsBlock/excursion';
import { useCityTagsCollectionsExperiment } from '@/features/experiments';

export function useExcursionCityTagsFiltering(cityTags: Ref<CityTag[] | undefined>) {
  const specialTags: Ref<CityTag[]> = ref([]);
  const popupTags: Ref<CityTag[]> = ref([]);
  const rubricsTags: Ref<CityTag[]> = ref([]);

  const filterTags = (tags: CityTag[] = []) => {
    const special: CityTag[] = [];
    const popup: CityTag[] = [];

    const filteredTags = tags.reduce((acc, tag) => {
      const slug = tag.slug ?? '';
      const { is_hidden: isHidden, is_seo_only: isSeoOnly } = tag.flags || {};
      const hasExperience = !!((tag?.counters?.excursions_count ?? 0) + (tag?.counters?.tours_count ?? 0));

      if (specialTagsSlugs.includes(slug) && !isHidden && !isSeoOnly) {
        special.push(tag);
      } else if (isHidden || isSeoOnly) {
        if (!isSeoOnly) {
          popup.push(tag);
        }
      } else if (hasExperience) {
        popup.push(tag);
      }

      if (!isHidden && !isSeoOnly && !specialTagsSlugs.includes(slug) && hasExperience) {
        acc.push(tag);
      }

      return acc;
    }, [] as CityTag[]);

    specialTags.value = special;
    popupTags.value = popup;

    return filteredTags;
  };

  const sortSpecialTags = () => {
    specialTags.value.sort(
      (a, b) =>
        (SpecialTagsOrder[a?.slug] || SpecialTagsOrder.default) -
        (SpecialTagsOrder[b?.slug] || SpecialTagsOrder.default),
    );
  };

  const { isExpActive } = useCityTagsCollectionsExperiment();

  watch(
    () => cityTags.value,
    () => {
      specialTags.value = [];
      popupTags.value = [];

      const filteredTags = isExpActive.value ? cityTags.value : filterTags(cityTags.value ?? []);

      sortSpecialTags();
      popupTags.value = specialTags.value.concat(popupTags.value);
      rubricsTags.value = specialTags.value.concat(filteredTags ?? []);
    },
    { deep: true, immediate: true },
  );

  return { popupTags, rubricsTags };
}
